class ViaCEPService {
  constructor() {
    this.cache = new Map();
    this.cacheTimeout = 60 * 60 * 1000;
    this.pendingRequests = new Map();
  }

  sanitizeCep(cep) {
    return String(cep || '').replace(/\D/g, '');
  }

  isValidCepFormat(cep) {
    return this.sanitizeCep(cep).length === 8;
  }

  getCached(cep) {
    const sanitized = this.sanitizeCep(cep);
    const cached = this.cache.get(sanitized);
    if (cached && Date.now() - cached.timestamp < this.cacheTimeout) {
      return cached.data;
    }
    return null;
  }

  setCache(cep, data) {
    this.cache.set(this.sanitizeCep(cep), { data, timestamp: Date.now() });
  }

  async buscarCep(cep) {
    const sanitized = this.sanitizeCep(cep);

    if (!this.isValidCepFormat(sanitized)) {
      throw new Error('CEP deve ter 8 dígitos');
    }

    const cached = this.getCached(sanitized);
    if (cached) {
      return { ...cached, cached: true };
    }

    if (this.pendingRequests.has(sanitized)) {
      return this.pendingRequests.get(sanitized);
    }

    const promise = (async () => {
      try {
        const response = await fetch(`https://viacep.com.br/ws/${sanitized}/json/`);
        if (!response.ok) {
          throw new Error(`Falha na consulta ao ViaCEP (HTTP ${response.status})`);
        }
        const data = await response.json();
        if (data && data.erro) {
          throw new Error('CEP não encontrado');
        }

        const normalized = {
          cep: data.cep || '',
          logradouro: data.logradouro || '',
          complemento: data.complemento || '',
          bairro: data.bairro || '',
          cidade: data.localidade || '',
          uf: data.uf || '',
          ibge: data.ibge || '',
          ddd: data.ddd || '',
        };

        this.setCache(sanitized, normalized);
        return normalized;
      } finally {
        this.pendingRequests.delete(sanitized);
      }
    })();

    this.pendingRequests.set(sanitized, promise);
    return promise;
  }
}

export default new ViaCEPService();
